<template>
  <div class="columns is-multiline">
    <div class="column is-12">
      <BContainer
        :title="$t('title.yourInternalAuditScore', [name])"
        containerClass="is-paddingless"
      >
        <BarChart
          v-if="componentData"
          name="components"
          :data="componentData.scores"
          :labels="componentData.labels"
          :horizantal="true"
        ></BarChart>
      </BContainer>
    </div>
    <div class="column is12">
      <BContainer :title="$t('title.whatIsScore', [name])" containerClass="is-paddingless">
        <p>
          Kontrol Bileşenleri iç kontrol ortamının kurulabilmesi ve sağlıklı bir şekilde
          sürdürülebilmesi için tanımlanmış işleyişlerdir. Bu işleyişlerden her hangi birinin eksik
          olması iç kontrol mekanizmasının etkinliğini ve güvenilirliğini negatif etkiler.
          Bileşenler hakkında detay açıklama ve pratik uygulama örnekleri için denetim raporuna
          bakabilirsiniz.
        </p>
      </BContainer>
    </div>
    <div class="column is-12">
      <BContainer :title="$t('title.yourScoreImprovement', [name])" containerClass="is-paddingless">
        <b-tabs
          type="is-boxed"
          vertical
          v-if="componentData && componentData.historicalScores"
          :multiline="true"
          :destroy-on-hide="true"
        >
          <b-tab-item :label="$t(`title.${key}`)" v-for="key in componentKeys" :key="key">
            <BarChart
              v-if="componentData.historicalScores[key]"
              :name="key"
              :data="componentData.historicalScores[key].scores"
              :labels="componentData.historicalScores[key].labels"
            ></BarChart>
          </b-tab-item>
        </b-tabs>
      </BContainer>
    </div>
  </div>
</template>
<script>
import DateFilter from '@/_helpers/date.filter'
import { BarChart } from '../../../components'

export default {
  props: ['data'],
  components: { BarChart },
  data() {
    return {
      name: this.$t('title.internalAuditComponents'),
      componentKeys: [
        'controlActivities',
        'controlEnvironment',
        'informationCommunication',
        'monitoring',
        'riskAssessment'
      ],
      componentData: null
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue) {
          const componentData = {
            labels: [],
            scores: [],
            historicalScores: {}
          }
          this.componentKeys.forEach(key => {
            const component = newValue[key]
            componentData.labels.push(this.$t(`title.${key}`))
            componentData.scores.push(component.score)

            const emptyDataCount = 4 - component.lastScores.length
            for (let index = 0; index < emptyDataCount; index++) {
              const element = { score: null, date: '' }
              component.lastScores.push(element)
            }
            componentData.historicalScores[key] = {
              scores: component.lastScores.map(s => s.score),
              labels: component.lastScores.map(s => DateFilter.date(s.date))
            }
          })
          this.componentData = componentData
        } else {
          this.componentData = null
        }
      }
    }
  }
}
</script>
